<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
		
      <div class="dlblock-mb20 mr10">
        <span class="pr5">商户编号</span>
        <el-input v-model.trim="subMerId" placeholder="请输入商户编号" style="width: 150px;"/>
      </div>

     <div class="dlblock-mb20 mr10">
        <span class="pr5">二级商户名称</span>
        <el-input v-model.trim="subMerName" placeholder="请输入商户名称" style="width: 150px;"/>
      </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="date"
	        style="width: 300px;"
	        type="daterange"
	        value-format="yyyy-MM-dd"
	        range-separator="至"
	        start-placeholder="开始日期"
	        end-placeholder="结束日期"/>
	  </div>
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getSnhMerchantPageFn()">
          搜索
        </el-button>
      </div>
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="editBtn(1)">
          新增
        </el-button>
		
      </div>
	  
	  <div>
		  
		<!--  <el-button type="primary" @click="editBtn(24)">
		    交易对账单下载
		  </el-button> -->
		  
		<!--  <el-button type="primary" @click="editBtn(23)">
		    交易流水查询
		  </el-button> -->
		 
		<!--  <el-button type="primary" @click="editBtn(25)">
		    平台商户对账单查询
		  </el-button> -->
		  
		 <!-- <el-button type="primary" @click="editBtn(45)">
		    微信支付宝对账单下载
		  </el-button> -->
		  
		<!--  <el-button type="primary" @click="editBtn(46)">
		    内转出金对账单下载
		  </el-button> -->
		  
	  </div>
	  
    </el-row>

	<br>
	
    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      
	  <el-table-column align="center" width="150" label="操作">
	    <template slot-scope="{row}">
	      <a class="glob-a"  @click="editBtn(2, row)">修改</a>
	  		  <a class="glob-a"  @click="editBtn(17, row)">更多</a>
	    </template>
	  </el-table-column>
	  
	  <el-table-column align="center"  label="收款码">
		  <template slot-scope="{row}">
		    <el-image class="m-box-img" :src="row.merQrCodeUrl" @click="editBtn(59,row)" lazy></el-image>
		  </template>
	  </el-table-column>
	  
	  <el-table-column align="center"  label="收款码logo">
	  		  <template slot-scope="{row}">
	  		    <el-image class="m-box-img" :src="row.merQrCodeLogoUrl" @click="editBtn(60,row)" lazy></el-image>
	  		  </template>
	  </el-table-column>
	  
	  <el-table-column align="center" prop="id" label="编号"></el-table-column>
	  <el-table-column align="center" prop="subMerId" label="二级商户编号"></el-table-column>
      <el-table-column align="center" prop="merchantId" label="二级商户同步编号"></el-table-column>
	  <el-table-column align="center" prop="subMerName" label="二级商户名称"></el-table-column>
	  <el-table-column align="center" prop="subMerTypeStr" label="二级商户类型"></el-table-column>
	  <el-table-column align="center" prop="subMerSort" label="排序方式"></el-table-column>
	  <el-table-column align="center" prop="certificateTypeStr" label="法定代表人或负责人证件类型"></el-table-column>
	  <el-table-column align="center" prop="certificateNo" label="法定代表人或负责人证件编号"></el-table-column>
	  <el-table-column align="center" prop="contactName" label="法定代表人或负责人名称"></el-table-column>
	  <el-table-column align="center" prop="companyName" label="企业名称"></el-table-column>
	  <el-table-column align="center" prop="companyCertType" label="企业证件类型"></el-table-column>
	  <el-table-column align="center" prop="companyCertNo" label="企业证件编号"></el-table-column>
	  <el-table-column align="center" prop="accountName" label="收款户名"></el-table-column>
	  <el-table-column align="center" prop="account" label="收款账号"></el-table-column>
	  <el-table-column align="center" prop="bankName" label="收款银行"></el-table-column>
	  <el-table-column align="center" prop="mobilePhone" label="银行预留手机号"></el-table-column>
	  <el-table-column align="center" prop="address" label="地址"></el-table-column>
	  <el-table-column align="center" prop="accountTypeStr" label="收款账户类型"></el-table-column>
	  <el-table-column align="center" prop="customTypeStr" label="客户类型"></el-table-column>
	  <el-table-column align="center" prop="notifyUrl" label="审核通知地址"></el-table-column>
	  <el-table-column align="center" prop="announce" label="声明已签署三方协议"></el-table-column>
	  <el-table-column align="center" prop="merMobilePhone" label="商户负责人联系电话"></el-table-column>
	  <el-table-column align="center" prop="remark" label="备注"></el-table-column>
	  <el-table-column align="center" prop="rspResults" label="响应结果"></el-table-column>
	  <el-table-column align="center" prop="stateStr" label="状态"></el-table-column>
	  <el-table-column align="center" prop="statusMessage" label="二级商户状态说明"></el-table-column>
	  <el-table-column align="center" prop="isPassed" label="审核状态"></el-table-column>
	  <el-table-column align="center" prop="agentSignNo" label="签约编号"></el-table-column>
	  <el-table-column align="center" prop="serialNo" label="序列号"></el-table-column>
	  <el-table-column align="center" prop="subMerchantAccNo" label="二级商户账号"></el-table-column>
	  <el-table-column align="center" prop="balance" label="余额"></el-table-column>
	  <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
	  <el-table-column align="center" prop="updateTime" label="更新时间"></el-table-column>
		  
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>
	
	<!-- 更多 -->
	<el-dialog title="更多" :visible.sync="dialogMore.modal" width="400px">
	  
	    <div style="text-align: center;">商户编号: {{dialogMore.moreRow.subMerId}} 商户名称: {{dialogMore.moreRow.subMerName}}</div><br>
	    
		 <!--   <a class="glob-a"  @click="editBtn(2, dialogMore.moreRow)">修改</a> -->
		          <a class="glob-a"  @click="editBtn(8, dialogMore.moreRow)">查看商户信息</a>  
				  <a class="glob-a"  @click="editBtn(18, dialogMore.moreRow)">商户信息同步old</a> </br>
				  <a class="glob-a"  @click="editBtn(20, dialogMore.moreRow)">商户信息同步new</a> 
				  <a class="glob-a"  @click="editBtn(9, dialogMore.moreRow)">签约短信验证码重发</a> </br>
				  <a class="glob-a"  @click="editBtn(7, dialogMore.moreRow)">签约</a> 
				  <a class="glob-a"  @click="editBtn(6, dialogMore.moreRow)">状态变更</a> </br>
				  <a class="glob-a"  @click="editBtn(10, dialogMore.moreRow)">余额查询</a> 
				  <a class="glob-a"  @click="editBtn(32, dialogMore.moreRow)">查询POS(二级)商户T日清算金额</a> </br>
				  <a class="glob-a"  @click="editBtn(44, dialogMore.moreRow)"> 出金交易请求</a> 
				  <a class="glob-a"  @click="editBtn(52, dialogMore.moreRow)">批量退款查询</a> 
				  <a class="glob-a"  @click="editBtn(57, dialogMore.moreRow)">收款码</a> 
				  <a class="glob-a"  @click="editBtn(61, dialogMore.moreRow)">二级商户证照资料上传</a> 
				  <a class="glob-a"  @click="editBtn(63, dialogMore.moreRow)">二级商户账簿余额查询</a>
				  <a class="glob-a"  @click="editBtn(65, dialogMore.moreRow)">商户支持支付方式</a>			
				  
				 </br></br>
				  
				  <a class="glob-a"  @click="toggle" >显示或隐藏</a>
				  
				  
				  <a v-if="showOrHide">
				  <a class="glob-a" style="color: red;">未完全打通版本 begin</a>
				 				  
				  <a class="glob-a"  @click="editBtn(11, dialogMore.moreRow)">8身份验证(非页面跳转)</a> 
				  <a class="glob-a"  @click="editBtn(12, dialogMore.moreRow)">9身份验证(页面跳转)</a>
				  <a class="glob-a"  @click="editBtn(13, dialogMore.moreRow)">10授权支付签约(银行端)</a> 
				  <a class="glob-a"  @click="editBtn(14, dialogMore.moreRow)">11授权支付签约(商户端)申请</a>
				  <a class="glob-a"  @click="editBtn(15, dialogMore.moreRow)">12授权支付签约(商户端)确认</a> </br>
				  <a class="glob-a"  @click="editBtn(16, dialogMore.moreRow)">13授权支付签约(商户端)验证码重发</a>
				  <a class="glob-a"  @click="editBtn(21, dialogMore.moreRow)">15授权支付签约/解约结果查询</a>
				  <a class="glob-a"  @click="editBtn(22, dialogMore.moreRow)">16授权支付解约</a> </br>
				  <a class="glob-a"  @click="editBtn(26, dialogMore.moreRow)">17预授权确认/取消(移到流水中)</a>
				  <a class="glob-a"  @click="editBtn(31, dialogMore.moreRow)">18第三方POS对账单下载</a> </br>
				  <a class="glob-a"  @click="editBtn(30, dialogMore.moreRow)">19二级商户迁移</a>
				  <a class="glob-a"  @click="editBtn(36, dialogMore.moreRow)">21 支付请求服务器</a>
				  <a class="glob-a"  @click="editBtn(37, dialogMore.moreRow)">22 支付请求页面</a> </br>
				  <a class="glob-a"  @click="editBtn(38, dialogMore.moreRow)">23 网上K码支付—支付请求</a>
				  <a class="glob-a"  @click="editBtn(39, dialogMore.moreRow)">24 网上K码支付—账单发送</a> </br>
				  <a class="glob-a"  @click="editBtn(40, dialogMore.moreRow)">25 网上K码支付—验证码重发</a>
				  <a class="glob-a"  @click="editBtn(41, dialogMore.moreRow)">26 批量授权扣款</a> </br>
				  <a class="glob-a"  @click="editBtn(42, dialogMore.moreRow)">27 批量授权扣款结果查询</a>
				  <a class="glob-a"  @click="editBtn(43, dialogMore.moreRow)">28 内转交易请求</a> </br>
				  <a class="glob-a"  @click="editBtn(47, dialogMore.moreRow)">30 担保确认查询请求</a> </br>
				  <a class="glob-a"  @click="editBtn(48, dialogMore.moreRow)">31 担保确认请求</a>
				  <a class="glob-a"  @click="editBtn(49, dialogMore.moreRow)">32 支出类账簿入金交易请求</a> </br>
				  <a class="glob-a"  @click="editBtn(50, dialogMore.moreRow)">33 刷卡支付订单撤销请求</a>
				  <a class="glob-a"  @click="editBtn(51, dialogMore.moreRow)">34 单笔授权扣款</a> </br>
				  <a class="glob-a"  @click="editBtn(53, dialogMore.moreRow)">36 批量退款</a> </br>
				  <a class="glob-a"  @click="editBtn(54, dialogMore.moreRow)">37 支付宝支付请求</a>
				  <a class="glob-a"  @click="editBtn(55, dialogMore.moreRow)">38 微信支付请求</a> </br>
				  <a class="glob-a"  @click="editBtn(56, dialogMore.moreRow)">39 扫码支付</a> 
				  <a class="glob-a"  @click="editBtn(19, dialogMore.moreRow)">14 掌银被扫支付请求</a> </br>
				  <a class="glob-a"  @click="editBtn(62, dialogMore.moreRow)">42 统一协议支付签约申请</a>
				  <a class="glob-a"  @click="editBtn(64, dialogMore.moreRow)">43 担保出金All</a>
				  <a class="glob-a"  @click="editBtn(68, dialogMore.moreRow)">44 担保出金All(垫资)</a>
				  <a class="glob-a"  @click="editBtn(66, dialogMore.moreRow)">45 担保出金</a>
				  <a class="glob-a"  @click="editBtn(67, dialogMore.moreRow)">46 担保出金(垫资)</a>
					
				  <a class="glob-a" style="color: red;" >未完全打通版本 end</a>
				  </br></br>				  
				  </a>
				  
				 
				  
				  <a class="glob-a"  @click="editBtn(5, dialogMore.moreRow)">删除</a>

	</el-dialog>
	
	<!-- 6.35	二级商户余额查询 查看 -->
	<el-dialog title="商户余额查询" :visible.sync="dialogMerchantBalance.modal" width="900px">
		<el-form label-width="160px">
		  <el-row>
		    <el-col :span="12">
		      <el-form-item label="商户编号：">
		        {{dialogMerchantBalance.data.merchant.merchantID}}
		      </el-form-item>
		    </el-col>
		    <el-col :span="12">
		      <el-form-item label="综合商户名称：">
		        {{dialogMerchantBalance.data.trxResponse.merchantName}}
		      </el-form-item>
		    </el-col>
		  </el-row>
		  <el-row>
		    <el-col :span="12">
		      <el-form-item label="余额：">
		        {{dialogMerchantBalance.data.trxResponse.balance}}
		      </el-form-item>
		    </el-col>
			<el-col :span="12">
				<el-form-item label="二级商户号：">
				  {{dialogMerchantBalance.data.trxResponse.subMerId}}
				</el-form-item>
			</el-col>
		  </el-row>
		   <el-row>
			   <el-col :span="12">
			     <el-form-item label="出金号：">
			       {{dialogMerchantBalance.data.trxResponse.subMerchantAccNo}}
			     </el-form-item>
			   </el-col>
		   </el-row>
		</el-form> 
	</el-dialog>
	
	
	<!-- 40	收款码 查看 -->
	<el-dialog title="收款码" :visible.sync="collectionCodeDialog.modal" width="500px">
		<el-form label-width="80px">
			
		  <el-row>
		    <el-col :span="12">
		      <el-form-item label="提示：" v-if=" collectionCodeDialog.msg != undefined " >
		        {{collectionCodeDialog.msg}}
		      </el-form-item>
		    </el-col>
		  </el-row>
		 
		   <el-row>
			   <el-col :span="20">
			     <el-form-item label="">
					 <el-image class="m-box-img" :src="collectionCodeUrl" @click="editBtn(58)" lazy></el-image>
				</el-form-item>
			   </el-col>
		   </el-row>
		   
		</el-form> 
	</el-dialog>

    <!-- 6.45	二级商户信息查询 查看 -->
    <el-dialog title="查看" :visible.sync="auditShow.modal" width="900px">
      <el-form label-width="160px" v-if="auditShow.data != undefined ">
        <el-row>
          <el-col :span="12">
            <el-form-item label="平台商户名称："  >
               {{auditShow.data.merchantName}} 
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二级商户编号：">
              {{auditShow.data.subMerId}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="二级商户名称：">
              {{auditShow.data.subMerName}}
            </el-form-item>
          </el-col>
		  <el-col :span="12">
		    <el-form-item label="排序方式：">
		      {{auditShow.data.subMerSort}}
		    </el-form-item>
		  </el-col>
        </el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="二级商户类型：">
		      {{auditShow.data.subMerchantType}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="法定代表人或负责人证件类型：">
		      {{auditShow.data.certificateType}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="法定代表人或负责人证件编号：">
		      {{auditShow.data.certificateNo}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="法定代表人或负责人名称：">
		      {{auditShow.data.contactName}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="银行预留手机号：">
		      {{auditShow.data.merMobileNo}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="状态：">
		      {{auditShow.data.status}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="二级商户状态说明：">
		      {{auditShow.data.statusMessage}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="企业证件类型：">
		      {{auditShow.data.companyCertType}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="企业证件号码：">
		      {{auditShow.data.companyCertNo}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="企业联系人名称：">
		      {{auditShow.data.companyName}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="通知地址：">
		      {{auditShow.data.notifyUrl}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="审核状态：">
		      {{auditShow.data.isPassed}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-table class="my-table" :data="auditShow.data.subAccountRecords" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
		  <el-table-column align="center" prop="accountType" label="账户类型"></el-table-column>
		  <el-table-column align="center" prop="accountName" label="账户名称"></el-table-column>
		  
		  <el-table-column align="center" prop="mobilePhone" label="二级商户手机号"></el-table-column>
		  <el-table-column align="center" prop="account" label="账户号"></el-table-column>
		  
		  <el-table-column align="center" prop="accountAbisNo" label="行内6网点号"></el-table-column>
		  <el-table-column align="center" prop="bankNo" label="账户开户行"></el-table-column>
		  
		  <el-table-column align="center" prop="accStatus" label="账户状态"></el-table-column>
		  <el-table-column align="center" prop="isABCAccount" label="是否是农行账号"></el-table-column>
		    
		</el-table>
		
		
      </el-form>
    </el-dialog>
	
	
	
	<!-- 二级商户账簿明细查询 交易明细释义 -->
	<el-dialog title="交易明细释义" :visible.sync="secondaryMerchantAccountBookDetailsQueryDataDetail.modal" width="900px">
	  <el-form label-width="160px" v-if="secondaryMerchantAccountBookDetailsQueryDataDetail.data != undefined ">
		<el-table class="my-table" :data="secondaryMerchantAccountBookDetailsQueryDataDetail.data" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
		  <el-table-column align="center" prop="transactionTimestamp" label="交易时间戳"></el-table-column>
		  <el-table-column align="center" prop="serialNumber" label="主机交易流水号"></el-table-column>
		  <el-table-column align="center" prop="money" label="交易金额"></el-table-column>
		</el-table>
	  </el-form>
	</el-dialog>
	
	
	<!-- 6.53	二级商户签约短信验证码重发 -->
	<el-dialog title="商户签约短信验证码重发" :visible.sync="signUpSMS.modal" width="400px">
	  <el-form label-width="120px">
	  <el-form-item label="出金卡号：">
	    <el-input v-model.trim="signUpSMS.subMerchantAccNo" placeholder="请输入出金卡号"/>
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="signUpSMS.modal = false">取 消</el-button>
	    <el-button type="primary" @click="signUpSMSBtn">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 二级商户出金交易 -->
	<el-dialog title="二级商户出金交易" :visible.sync="secondaryMerchantsPaymentTransaction.modal" width="400px">
	  <el-form label-width="120px">
	  <el-form-item label="金额：">
	    <el-input v-model.trim="secondaryMerchantsPaymentTransaction.amountOfMoney" placeholder="金额"/>
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="secondaryMerchantsPaymentTransaction.modal = false">取 消</el-button>
	    <el-button type="primary" @click="secondaryMerchantsPaymentTrans">确 定</el-button>
	  </div>
	</el-dialog>

  <!-- 新增编辑 -->
    <el-dialog :title="editData.add === 1 ? '新增商户' : '编辑商户'" :visible.sync="editData.modal" width="800px">
      <el-form label-width="220px">
        <el-form-item label="二级商户名称：">
          <el-input v-model.trim="editData.subMerName" placeholder="请输入二级商户名称"/>
        </el-form-item>
        <el-form-item label="二级商户类型：">
			<el-select v-model="editData.subMerType" class="w150" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in subMerTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
        </el-form-item>
        <el-form-item label="排序方式：">
		  <el-input v-model.trim="editData.subMerSort" placeholder="请输入排序方式"/>
		</el-form-item> 
		<el-form-item label="法定代表人或负责人证件类型：">
			<el-select v-model="editData.certificateType" class="w150" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in certificateTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item>
		<el-form-item label="法定代表人或负责人证件编号：">
		  <el-input v-model.trim="editData.certificateNo" placeholder="请输入法定代表人或负责人证件编号"/>
		</el-form-item>
		<el-form-item label="法定代表人或负责人名称：">
		  <el-input v-model.trim="editData.contactName" placeholder="请输入法定代表人或负责人名称"/>
		</el-form-item>
		<el-form-item label="企业名称：" v-if="editData.subMerType == 2 ">
		  <el-input v-model.trim="editData.companyName" placeholder="企业商户必输"/>
		</el-form-item>
		<el-form-item label="企业证件类型：" v-if="editData.subMerType == 2 " >
			<el-select v-model="editData.companyCertType" class="w150" placeholder="企业商户必选" clearable>
			  <el-option v-for="(item, index) in companyCertTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item>
		<el-form-item label="企业证件编号：" v-if="editData.subMerType == 2 ">
		  <el-input v-model.trim="editData.companyCertNo" placeholder="企业商户必输"/>
		</el-form-item>
		<el-form-item label="收款户名：">
		  <el-input v-model.trim="editData.accountName" placeholder="请输入收款户名"/>
		</el-form-item>
		<el-form-item label="收款账号：">
		  <el-input v-model.trim="editData.account" placeholder="请输入收款账号"/>
		</el-form-item>
		<el-form-item label="收款银行：">
		  <el-input v-model.trim="editData.bankName" placeholder="请输入收款银行"/>
		</el-form-item>
		<el-form-item label="银行预留手机号：">
		  <el-input v-model.trim="editData.mobilePhone" placeholder="请输入银行预留手机号"/>
		</el-form-item>
		<el-form-item label="地址：">
		  <el-input v-model.trim="editData.address" placeholder="非必须"/>
		</el-form-item>
		<el-form-item label="收款账户类型：">
			<el-select v-model="editData.accountType" class="w150" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in accountTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item>
		<el-form-item label="商户负责人联系电话：">
		  <el-input v-model.trim="editData.merMobilePhone" placeholder="请输入商户负责人联系电话"/>
		</el-form-item>
		<el-form-item label="备注：">
		  <el-input v-model.trim="editData.remark" placeholder="非必须"/>
		</el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="editData.modal = false">取 消</el-button>
        <el-button type="primary" @click="addBtn">确 定</el-button>
      </div>
    </el-dialog>
	
	<!-- 商户状态设置 -->
	<el-dialog title="商户状态设置" :visible.sync="statusData.modal" width="350px">
	  <el-form :model="statusData" >
	    <el-form-item label="商户状态：">
	    	<el-select v-model="statusData.updateFlag" class="w170" placeholder="选择" clearable>
	    	  <el-option v-for="(item, index) in merchantList" :key="index" :label="item.name" :value="item.value"/>
	    	</el-select>
	    </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="statusData.modal = false">取 消</el-button>
	    <el-button type="primary" @click="statusSave">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 商户签约设置 -->
	<el-dialog title="商户签约设置" :visible.sync="signAcontractData.modal" width="380px">
	<el-form :model="signAcontractData" >	
	
	<el-form-item label="签约方式：">
		<el-select v-model="signAcontractData.signAcontractDataListIndex" class="w220" placeholder="必选" clearable>
		  <el-option v-for="(item, index) in signAcontractDataList" :key="index" :label="item.name" :value="item.value"/>
		</el-select>
	</el-form-item>
	
	  <el-form-item label="短信验证码：" v-if=" signAcontractData.signAcontractDataListIndex == 1 ">
	    <el-input v-model.trim="signAcontractData.verificationCode" placeholder="请输入短信验证码"/>
	  </el-form-item>
	  <el-form-item label="随机金额：" v-if=" signAcontractData.signAcontractDataListIndex == 2 ">
	    <el-input v-model.trim="signAcontractData.randomAmount" placeholder="请输入随机金额"/>
	  </el-form-item>
	<!--  <el-form-item label="出金卡号：">
	    <el-input v-model.trim="signAcontractData.account"  placeholder="请输入出金卡号"/>
	  </el-form-item> -->
	  </el-form>
	  <div slot="footer">
	    <el-button @click="signAcontractData.modal = false">取 消</el-button>
	    <el-button type="primary" @click="signAcontract">确 定</el-button>
	  </div>
	</el-dialog>
	
	
	<!-- 二级商户证照资料上传 -->
	<el-dialog title="二级商户证照资料上传" :visible.sync="uploadSubMerCertRequestDialog.modal" width="380px">
	<el-form :model="uploadSubMerCertRequestDialog">	
	
	<el-form-item label="上传标识：">
		<el-select v-model="uploadSubMerCertRequestDialog.Flag" class="w220" placeholder="必选" clearable>
		  <el-option v-for="(item, index) in uploadSubMerCertRequestDataList" :key="index" :label="item.name" :value="item.value"/>
		</el-select>
	</el-form-item>
	
	  <el-form-item label="上传ZIP文件，最大1.5M：" >
	    <el-input v-model.trim="uploadSubMerCertRequestDialog.subMerCertFile" placeholder="请选择上传zip压缩文件"/>
	  </el-form-item>
	<!--  <el-form-item label="出金卡号：">
	    <el-input v-model.trim="signAcontractData.account"  placeholder="请输入出金卡号"/>
	  </el-form-item> -->
	  </el-form>
	  <div slot="footer">
	    <el-button @click="uploadSubMerCertRequestDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="uploadSubMerCertRequest">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 授权支付签约(商户端)确认 -->
	<el-dialog title="授权支付签约(商户端)确认" :visible.sync="authorizedPaymentSigningMerchantSideConfirmationDialog.modal" width="380px">
	<el-form :model="authorizedPaymentSigningMerchantSideConfirmationDialog" >	
	  <el-form-item label="验证码(非必须)：" >
	    <el-input v-model.trim="authorizedPaymentSigningMerchantSideConfirmationDialog.verificationCode" placeholder="请输入验证码"/>
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="authorizedPaymentSigningMerchantSideConfirmationDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="authorizedPaymentSigningMerchantSideConfirmationFn">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 14、交易明细查询 -->
	<el-dialog title="交易明细查询" :visible.sync="transactionDetailsData.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="transactionDetailsData.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="transactionDetailsData.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="transactionDetailsData.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  <!-- <el-input v-model.trim="transactionDetailsData.zip" placeholder="请选择压缩标识*"/> -->
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="transactionDetailsData.modal = false">取 消</el-button>
	    <el-button type="primary" @click="transactionDetails">确 定</el-button>
	  </div>
	</el-dialog>
	
	
	
	<!-- 二级商户账簿明细查询 -->
	<el-dialog title="二级商户账簿明细查询" :visible.sync="secondaryMerchantAccountBookDetailsQueryData.modal" width="286px">
	<el-form :model="secondaryMerchantAccountBookDetailsQueryData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="secondaryMerchantAccountBookDetailsQueryData.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyyMMdd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="secondaryMerchantAccountBookDetailsQueryData.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyyMMdd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   

	  </el-form>
	  <div slot="footer">
	    <el-button @click="secondaryMerchantAccountBookDetailsQueryData.modal = false">取 消</el-button>
	    <el-button type="primary" @click="secondaryMerchantAccountBookDetailsQuery">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 微信支付宝对账单下载 -->
	<el-dialog title="微信支付宝对账单下载" :visible.sync="weChatAlipayBillPaymentDialog.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="weChatAlipayBillPaymentDialog.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="weChatAlipayBillPaymentDialog.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="weChatAlipayBillPaymentDialog.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  <!-- <el-input v-model.trim="transactionDetailsData.zip" placeholder="请选择压缩标识*"/> -->
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="weChatAlipayBillPaymentDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="weChatAlipayBillPayment">确 定</el-button>
	  </div>
	</el-dialog>
	
	
	<!-- 微信支付宝对账单下载 -->
	<el-dialog title="内转出金对账单下载" :visible.sync="downloadInternalTransferOutStatementDialog.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="downloadInternalTransferOutStatementDialog.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="downloadInternalTransferOutStatementDialog.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="downloadInternalTransferOutStatementDialog.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  <!-- <el-input v-model.trim="transactionDetailsData.zip" placeholder="请选择压缩标识*"/> -->
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="downloadInternalTransferOutStatementDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="downloadInternalTransferOutStatement">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 6.11	交易对账单下载 -->
	<el-dialog title="交易对账单下载" :visible.sync="transactionAccountStatementDialog.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="transactionAccountStatementDialog.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="transactionAccountStatementDialog.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="transactionAccountStatementDialog.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  <!-- <el-input v-model.trim="transactionDetailsData.zip" placeholder="请选择压缩标识*"/> -->
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="transactionAccountStatementDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="transactionAccountStatement">确 定</el-button>
	  </div>
	</el-dialog>
	
	
	<!-- 6.8	批量退款查询 -->
	<el-dialog title="批量退款查询" :visible.sync="batchRefundQueryDialog.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="batchRefundQueryDialog.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="batchRefundQueryDialog.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="批量编号：*必输">
		  <el-input v-model.trim="batchRefundQueryDialog.serialNumber" placeholder="请输入批量编号"/>
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="batchRefundQueryDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="batchRefundQuery">确 定</el-button>
	  </div>
	</el-dialog>

	<!-- 6.40	平台商户对账单下载 -->
	<el-dialog title="平台商户对账单下载" :visible.sync="platformMerchantStatementDialog.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="platformMerchantStatementDialog.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="platformMerchantStatementDialog.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="platformMerchantStatementDialog.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  <!-- <el-input v-model.trim="transactionDetailsData.zip" placeholder="请选择压缩标识*"/> -->
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="platformMerchantStatementDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="platformMerchantStatement">确 定</el-button>
	  </div>
	</el-dialog>


	<!-- 图片放大 -->
	<el-dialog title="查看" :visible.sync="imgPreData.modal" width="600px" height="600px">
	  <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
	</el-dialog>

	<!-- 1 第三方POS对账单下载 -->
	<el-dialog title="第三方POS对账单下载" :visible.sync="thirdPartyPosStatementDownloadDialog.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  	    <el-date-picker
		  	        v-model="thirdPartyPosStatementDownloadDialog.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	  </el-form-item>
	  <el-form-item label="查询结束日期：*必输">
	  		  	    <el-date-picker
	  		  	        v-model="thirdPartyPosStatementDownloadDialog.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  </el-form-item>
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="thirdPartyPosStatementDownloadDialog.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="thirdPartyPosStatementDownloadDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="thirdPartyPosStatementDownload">确 定</el-button>
	  </div>
	</el-dialog>
	
	
	<!-- 查询POS(二级)商户T日清算金额 -->
	<el-dialog title="查询POS(二级)商户T日清算金额" :visible.sync="queryTheSettlementAmountOfPosSecondaryMerChantOntDayDialog.modal" width="326px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  	    <el-date-picker
		  	        v-model="queryTheSettlementAmountOfPosSecondaryMerChantOntDayDialog.trxDate"
		  	        style="width:280px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	  </el-form-item>
	  <el-form-item label="查询结束日期：*必输">
	  		  	    <el-date-picker
	  		  	        v-model="queryTheSettlementAmountOfPosSecondaryMerChantOntDayDialog.trxDateEnd"
	  		  	        style="width:280px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="queryTheSettlementAmountOfPosSecondaryMerChantOntDayDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="queryTheSettlementAmountOfPosSecondaryMerChantOntDay">确 定</el-button>
	  </div>
	</el-dialog>
	
	
	<!-- 商户支持支付方式 -->
	  <el-dialog title="商户支持支付方式" :visible.sync="merchantSupportsPaymentMethodDialog.modal" width="400px">
	    <el-form label-width="100px">
	      <el-form-item label="商户名称：">
			  {{merchantSupportsPaymentMethodDialog.merchantName}}
	      </el-form-item>
	      
		  <el-form-item label="支付渠道：">
				<el-checkbox-group v-model="merchantSupportsPaymentMethodDialog.paymentChannelsArray" @change="handleCheckedCitiesChange" >
				    <el-checkbox label="农行掌银" ></el-checkbox>
					<el-checkbox label="农行快E支付" ></el-checkbox>
				    <el-checkbox label="微信"   ></el-checkbox>
				    <el-checkbox label="支付宝" ></el-checkbox>
				  </el-checkbox-group>
		  </el-form-item>
		  
	    </el-form>
	
	    <div slot="footer">
	      <el-button @click="merchantSupportsPaymentMethodDialog.modal = false">取 消</el-button>
	      <el-button type="primary" @click="merchantSupportsPaymentMethodDialogBtn">确 定</el-button>
	    </div>
	  </el-dialog>
	  
	
  </div>
</template>

<script>
  import {
	//二级商户信息分页查看
    getSnhMerchantPage,
	//二级商户标记删除
	delSnhMerchantPage,
	//二级商户信息保存
	SecondaryMerchantsSynchronizeNew,
	//6.48	二级商户信息同步（新）
	secondaryMerchantInformationSynchronizationNew,
	//6.49	二级商户状态变更请求
	secondaryMerchantStatusChangeRequest,
	//6.5	二级商户签约确认
	signingConfirmationOfSecondaryMerchants,
	//6.45	二级商户信息查询
	secondaryMerchantInformationQuery,
	//6.35	二级商户余额查询
	secondaryMerchantBalanceQuery,
	//6.53	二级商户签约短信验证码重发
	sendMobileMessageForSubMerRequest,
	//6.26	身份验证（非页面跳转）
	authenticationNonPageJump,
	//6.24	身份验证（页面跳转）
	authenticationPageJump,
	//6、授权支付签约（银行端）
	authorizedPaymentSigningBankEnd,
	//6.16	授权支付签约（商户端）—申请
	authorizedPaymentSigningMerchantSideApplication,
	//6.17	授权支付签约（商户端）—确认
	authorizedPaymentSigningMerchantSideConfirmation,
	//6.18	授权支付签约（商户端）—验证码重发
	authorizedPaymentSigningMerchantSideVerificationCodeResend,
	//6.32	二级商户信息同步（不再支持）
	ydSnhRegSubMerchantInfoRequestOld,
	//6.44	掌银被扫支付请求
	ydSnhPalmBankIsSweptToPay,
	//6.20	授权支付签约/解约结果查询
	ydAuthorizedPaymentSigningCancelingResultQuery,
	//6.19	授权支付解约
	ydTerminationOfAuthorizedPayment,
	//6.11	对账单查询
	ydStatementQuery,
	//6.40	平台商户对账单下载
	ydPlatformMerchantStatementDownload,
	//6.27	预授权确认/取消
	ydPreAuthorizationConfirmationCancellation,
	//6.38	电子回单下载
	ydElectronicReceiptDownload,
	//6.40	鉴权交易结果查询（不再支持）
	ydAuthenticationQuery,
	//6.42	出金交易查询
	ydDepositTransactionInquiry,
	//6.46	二级商户迁移
	ydSecondaryBusinessMigration,
	//1、第三方POS对账单下载
	ydPOSThirdFileDownloadRequest,
	//2、查询POS（二级）商户T日清算金额
	ydQuerySubMerTdaySettleRequest,
	//3、第三方POS订单登记
	ydRegisterPOSOrderRequest,
	//4、第三方交易渠道订单确认
	ydThirdConfirmSendMQOrderRequest,
	//5、第三方交易渠道订单同步
	ydBatchRegisterRequest,
	//6.10	交易明细查询
	ydTransactionDetailEnquiry,
	//6.3	支付请求   6.3.1	方式1：通过与农行服务器建立连接访问农行支付平台服务
	ydPaymentRequest,
	//6.3	支付请求  6.3.2	方式2：通过页面传参提交表单方式访问农行支付平台服务
	ydPaymentRequestTwo,
	//6.13	网上K码支付—支付请求
	ydOnlineKCodePaymentPaymentRequest,
	//6.12	网上K码支付—账单发送
	ydOnlineKcodePaymentBillSending,
	//6.14	网上K码支付—验证码重发
	ydOnlineKCodePaymentVerificationCodeRetransmission,
	//6.22	批量授权扣款
	ydBatchAuthorizedDeduction,
	//6.23	批量授权扣款结果查询
	ydBatchAuthorizationDeductionResultQuery,
	//6.33	内转交易请求
	ydInternalTransferTransactionRequest,
	//6.34	出金交易请求
	ydCashTransactionRequest,
	//6.36	微信支付宝对账单下载
	ydWeChatAlipayBillPayment,
	//6.37	内转出金对账单下载
	ydDownloadInternalTransferOutStatement,
	//7.4	担保确认查询请求
	ydGuaranteeConfirmationInquiryRequest,
	//7.3	担保确认请求
	ydGuaranteeConfirmationRequest,
	//6.47	支出类账簿入金交易请求
	ydPaymentTransactionRequestOfExpenseAccountBook,
	//6.43	刷卡支付订单撤销请求
	ydCreditCardPaymentOrderCancellationRequest,
	//6.21	单笔授权扣款
	ydSingleAuthorizedDeduction,
	//6.8	批量退款查询
	ydBatchRefundQuery,
	//6.7	批量退款
	ydBatchRefund,
	//6.31	支付宝支付请求
	ydAlipayPaymentRequest,
	//6.30	微信支付请求
	ydWechatPaymentRequest,
	//扫码支付
	ydPaymentByScanningCode,
	//商户收款码
	ydGetCollectionCode,
	//二级商户证照资料上传
	ydUploadSubMerCertRequest,
	//统一协议支付签约申请
	ydUnifiedSignApply,
	//二级商户账簿明细查询
	getCheckSubMerAccDetailRequest,
	//担保出金All
	ydTestGuaranteePayment,
	//担保出金one
	ydGuaranteedWithdrawalOne,
	//商户支持支付方式
	ydMerchantSupportsPaymentMethod
  } from '@/api'

   import WordImg from '@/components/WordImg.vue'

  export default {
    name: 'WordList',
    components: {WordImg},
    data () {
      return {
		//二级商户编号
		subMerId:'',
		//二级商户名称
		subMerName:'',
        date: '',
        userName: '',
        tableData: [],
        tableLoading: false,
		//更多
		dialogMore:{
		modal:false,
		//更多选中操作列表中的一条
		moreRow:{}
		},
		//6.35	二级商户余额查询 查看
		dialogMerchantBalance:{
		  modal:false,
		  data:{
			  merchant:{merchantID:''},
			  trxResponse:{merchantName:''}
		  }
		},
		//40 收款码
		//二维码展示url
		collectionCodeUrl:'',
		collectionCodeDialog:{
		  modal:false,
		
		  //提示消息
		  msg:''
		},
		//6.45	二级商户信息查询
        auditShow: {
          modal: false,
          data: {
			  merchantName:'',
			  subAccountRecords:{}
		  }
        },
		//6.53	二级商户签约短信验证码重发
		signUpSMS:{
			modal: false,
			data: {}
		},
		//二级商户出金交易
		signUpSMS:{
			modal: false,
			data: {}
		},
		//二级商户出金交易
		secondaryMerchantsPaymentTransaction:{
			modal: false
		},	
		//二级商户类型
		subMerTypeList:[{name:"请选择",value:""},{name:"自然人",value:"1"},{name:"企业商户",value:"2"},{name:"个体工商户",value:"3"}],
		//法定代表人或负责人证件类型
		certificateTypeList:[{name:"请选择",value:""},{name:"身份证",value:"I"},{name:"护照",value:"P"},{name:"军官证",value:"G"},{name:"其它证件",value:"U"}],	
		//企业证件类型
		companyCertTypeList:[{name:"请选择",value:""},{name:"营业执照",value:"U"},{name:"组织机构代码证",value:"Y"},{name:"统一社会信用代码",value:"V"}],
		//收款账户类型
		accountTypeList:[{name:"请选择",value:""},{name:"借记卡",value:"401"},{name:"对公卡",value:"601"}],
		//商户状态
		merchantList:[{name:"请选择",value:""},{name:"开启",value:"6"},{name:"关闭",value:"5"},{name:"解约",value:"4"}],
		//签约 1短信验证码 2随机金额 二者选1
		signAcontractDataList:[{name:"短信验证码",value:"1"},{name:"随机金额",value:"2"}],
		//二级商户证照资料上传
		uploadSubMerCertRequestDataList:[{name:"营业执照照片",value:"1"},{name:"法人/负责人身份证正反面照片",value:"2"},{name:"辅助证明材料",value:"3"}],
		//单词新增和修改
        editData: {
          modal: false,
          userId: '',
          add: 1,
		  //二级商户名称
          subMerName: '',
		  //二级商户类型
		  subMerType:'',
		  //排序方式
		  subMerSort:'',
		  //法定代表人或负责人证件类型
		  certificateType:'',
		  //法定代表人或负责人证件编号
		  certificateNo:'',
		  //法定代表人或负责人名称
		  contactName:'',
		  //企业名称
		  companyName:'',
		  //企业证件类型
		  companyCertType:'',
		  //企业证件编号
		  companyCertNo:'',
		  //收款户名
		  accountName:'',
		  //收款账号
		  account:'',
		  //收款银行
		  bankName:'',
		  //银行预留手机号
		  mobilePhone:'',
		  //地址
		  address:'',
		  //收款账户类型
		  accountType:'',
		  //商户负责人联系电话
		  merMobilePhone:'',
		  //备注
		  remark:''
        },
		//商户支持支付方式
		merchantSupportsPaymentMethodDialog:{
			modal: false,
			id:'',
			merchantName:'',
			//支付渠道 数组
			paymentChannelsArray:[]
		},
		// 商户状态变更
		statusData: {
		  modal: false,
		  userId: '',
		  type: '',
		  typeName: '',
		  date: [],
		  content: ''
		},
		//商户签约设置
		signAcontractData:{
			modal: false,
			subMerId: '',
			//签约方式选择
			signAcontractDataListIndex:'1',
			verificationCode:'',
			randomAmount:'',
			account:''
		},
		//二级商户证照资料上传
		uploadSubMerCertRequestDialog:{
			modal: false,
			//二级商户编号	
			subMerId: '',
			//上传标识： 1、营业执照照片 2、法人/负责人身份证正反面照片， 3、辅助证明材料
			flag:'',
			//上传 ZIP 文件，最大 1.5M
			subMerCertFile:'',
		},
		//6.17	授权支付签约（商户端）—确认
		authorizedPaymentSigningMerchantSideConfirmationDialog:{
			modal: false,
			//交易编号
			orderNo:"",
			//验证码	
			verificationCode:""
		},
		//14 交易明细查询
		transactionDetailsData:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//二级商户账簿明细查询
		secondaryMerchantAccountBookDetailsQueryData:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
		},
		//二级商户账簿明细查询 交易明细释义
		secondaryMerchantAccountBookDetailsQueryDataDetail:{
			modal: false,
			data:""
		},
		//微信支付宝对账单下载
		weChatAlipayBillPaymentDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//6.37	内转出金对账单下载
		downloadInternalTransferOutStatementDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//6.11 交易对账单下载
		transactionAccountStatementDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//6.40	平台商户对账单下载
		platformMerchantStatementDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//6.8	批量退款查询
		batchRefundQueryDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//批量编号
			serialNumber:''
		},
		//1、第三方POS对账单下载
		thirdPartyPosStatementDownloadDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//查询POS(二级)商户T日清算金额
		queryTheSettlementAmountOfPosSecondaryMerChantOntDayDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			trxDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			trxDateEnd:'',
			//二级商户id
			subMerId:''
		},
        typeList: [],
        pages: {
          page: 1,
          total: 0
        },
		imgTotal: 1,
		// 图片上传
		imgUploadData: {
		  modal: false,
		  urlList: []
		},
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
		//显示或隐藏
		showOrHide:false
      }
    },
    created () {
      this.getSnhMerchantPageFn()
    },
    methods: {
		//6.48	二级商户信息同步（新）
		secondaryMerchantInformationSynchronizationNewFn(){
		  this.tableLoading = true
		  secondaryMerchantInformationSynchronizationNew({
			  id:this.editData.id
		  }).then(res => {
			  console.info(res,"================6.48	二级商户信息同步（新）")
			  if( res.code == 200 ){
				  this.$message.success(res.data)
			  }else{
				  this.$message.success(res.msg) 
			  }
			  this.tableLoading = false
			  this.getSnhMerchantPageFn()
		  }).finally(() => {
		    this.tableLoading = false
		  })
		},
      getSnhMerchantPageFn(){
        this.tableLoading = true
        getSnhMerchantPage({
          pageNum: this.pages.page,
          createTime: this.date && this.date.length ? this.date[0] : '',
          updateTime: this.date && this.date.length > 1 ? this.date[1] : '',
          subMerId: this.subMerId,
          subMerName: this.subMerName
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
	  //6.49	二级商户状态变更请求
	  statusSave(){
		 console.info("二级商户状态变更请求",this.statusData.subMerId);
		 this.tableLoading = true
		 secondaryMerchantStatusChangeRequest({subMerId:this.statusData.subMerId,
		 updateFlag:this.statusData.updateFlag}).then(res => {
		  this.$message.success(res.data)
		  //关闭弹窗
		  this.statusData = {modal: false}
		  this.tableLoading = false
		  this.getSnhMerchantPageFn()
		 }).finally(() => {
		   this.tableLoading = false
		 }) 
	  },
	  //6.35	二级商户余额查询
	  secondaryMerchantBalanceQueryFn(subMerId){
		 console.info("二级商户余额查询",subMerId);
		 this.tableLoading = true
		 secondaryMerchantBalanceQuery({subMerId:subMerId}).then(res => {
		  if(res.code == 200){
			 //弹出二级商户余额 显示dialog
			 //更多
			 this.dialogMerchantBalance = {
			 	  modal:true,
			 	  data:res.data	  
			 }
			  console.info("6.35	二级商户余额查询 ",this.dialogMerchantBalance);	 
			  this.$message.success(res.msg)
		  }else{
			  this.$message.success(res.msg)
		  }
		  this.tableLoading = false
		 }).finally(() => {
		   this.tableLoading = false
		 })  
	  },
	  //商户签约
	  signAcontract(){
		  let signMode = this.signAcontractData.signAcontractDataListIndex
		  if(signMode == undefined || signMode == ''){
			  this.$message.error("请选择商户签约方式！")
			  return
		  }
		  console.info("二级商户签约",this.signAcontractData.subMerId);
		  this.tableLoading = true
		  signingConfirmationOfSecondaryMerchants({
			  subMerchantNo:this.signAcontractData.subMerId,
		      verificationCode:this.signAcontractData.verificationCode,
			  randomAmount:this.signAcontractData.randomAmount,
			  account:this.signAcontractData.account,
		  }).then(res => {
			//签约
		   this.signAcontractData = { modal: false }
		   this.$message.success(res.msg)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //二级商户证照资料上传
	  uploadSubMerCertRequest(){
		  console.info("二级商户签约",this.signAcontractData.subMerId);
		  this.tableLoading = true
		  ydUploadSubMerCertRequest({
		  			  subMerNo:this.uploadSubMerCertRequestDialog.subMerId,
					  flag:this.uploadSubMerCertRequestDialog.flag,
		  			  subMerCertFile:this.uploadSubMerCertRequestDialog.subMerCertFile
		  }).then(res => {
		   this.uploadSubMerCertRequestDialog = { modal: false }
		   this.$message.success(res.msg)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //6.17	授权支付签约（商户端）—确认
	  authorizedPaymentSigningMerchantSideConfirmationFn(){
		  			this.tableLoading = true
		  			authorizedPaymentSigningMerchantSideConfirmation({ 
		  				//交易编号	
		  				orderNo:this.authorizedPaymentSigningMerchantSideConfirmationDialog.agentSignNo,
		  				//验证码	
		  				verifyCode:this.authorizedPaymentSigningMerchantSideConfirmationDialog.verificationCode
		  			}).then(res => {
		  			 this.$message.success(res.msg)
		  			 this.tableLoading = false
					 this.authorizedPaymentSigningMerchantSideConfirmationDialog = { modal: false }
		  			}).finally(() => {
		  			  this.tableLoading = false
		  			}) 
	  },
	  //6.10	交易明细查询
	  transactionDetails(){
		  this.tableLoading = true
		  ydTransactionDetailEnquiry({
					  //查询日期	必须设定，YYYY/MM/DD
		  			  settleDate:this.transactionDetailsData.settleDate,
					  //查询结束日期 必须设定，YYYY/MM/DD
					  settleDateEnd:this.transactionDetailsData.settleDateEnd,
					  //压缩标识	必须设定，1：压缩，0：不压缩
		  			  zip:this.transactionDetailsData.zip
		  }).then(res => {
		   this.transactionDetailsData = { modal: false }
		   this.$message.success(res.msg)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //二级商户账簿明细查询
	  secondaryMerchantAccountBookDetailsQuery(){
		  this.tableLoading = true
		  			getCheckSubMerAccDetailRequest({
		  				//子商户号
		  				subMerchantNo:this.secondaryMerchantAccountBookDetailsQueryData.subMerId,
		  				//开始日期
		  				startDate:this.secondaryMerchantAccountBookDetailsQueryData.settleDate,
		  				//结束日期
		  				endDate:this.secondaryMerchantAccountBookDetailsQueryData.settleDateEnd,
		  			}).then(res => {
						if(res.code === 200){
						    this.secondaryMerchantAccountBookDetailsQueryDataDetail = { modal : true, data:res.data }
		  				}else{
							this.$message.success(res.msg)
						}
						//this.getSnhMerchantPageFn();
		  			}).finally(() => {
		  			  this.tableLoading = false
		  			})
	  },
	  //6.36	微信支付宝对账单下载
	  weChatAlipayBillPayment(){
	  		  //6.36	微信支付宝对账单下载
	  		  this.tableLoading = true
	  		  	ydWeChatAlipayBillPayment({
	  		  		//对账日期	必须设定，YYYY/MM/DD
	  		  		settleDate:this.weChatAlipayBillPaymentDialog.settleDate,
					settleDateEnd:this.weChatAlipayBillPaymentDialog.settleDateEnd,
	  		  		//压缩标识	必须设定，1：压缩，0：不压缩
	  		  		zip:this.weChatAlipayBillPaymentDialog.zip
	  		  		}).then(res => {
						this.weChatAlipayBillPaymentDialog = { modal: false }
	  		  			this.$message.success(res.data)
	  		  			this.getSnhMerchantPageFn();
	  		  		}).finally(() => {
	  		  			this.tableLoading = false
	  		  	})
	  },
	 //6.37	内转出金对账单下载
	  downloadInternalTransferOutStatement(){
			//6.37	内转出金对账单下载
			this.tableLoading = true
			ydDownloadInternalTransferOutStatement({
				//对账日期	必须设定，YYYY/MM/DD
				settleDate:this.downloadInternalTransferOutStatementDialog.settleDate,
				settleDateEnd:this.downloadInternalTransferOutStatementDialog.settleDateEnd,
				//压缩标识	必须设定，1：压缩，0：不压缩
				zip:this.downloadInternalTransferOutStatementDialog.zip
			}).then(res => {
				this.downloadInternalTransferOutStatementDialog = { modal: false }
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
	  },
	  //6.11 交易对账单下载
	  transactionAccountStatement(){
		  this.tableLoading = true
		  			ydStatementQuery({
		  				//查询日期	必须设定，YYYY/MM/DD
		  				settleDate:this.transactionAccountStatementDialog.settleDate,
		  				//查询结束日期 必须设定，YYYY/MM/DD
		  				settleDateEnd:this.transactionAccountStatementDialog.settleDateEnd,
		  				//压缩标识	必须设定，1：压缩，0：不压缩
		  				zip:this.transactionAccountStatementDialog.zip
		  			}).then(res => {
						this.transactionAccountStatementDialog = { modal: false }
		  				this.$message.success(res.data)
		  				this.getSnhMerchantPageFn();
		  			}).finally(() => {
		  			  this.tableLoading = false
		  			})
	  },
	  //6.40	平台商户对账单下载
	  platformMerchantStatement(){
		  //6.40	平台商户对账单下载
		  			this.tableLoading = true
		  			ydPlatformMerchantStatementDownload({
		  				//查询日期	必须设定，YYYY/MM/DD
		  				settleDate:this.platformMerchantStatementDialog.settleDate,
		  				//查询结束日期 必须设定，YYYY/MM/DD
		  				settleDateEnd:this.platformMerchantStatementDialog.settleDateEnd,
		  				//压缩标识	必须设定，1：压缩，0：不压缩
		  				zip:this.platformMerchantStatementDialog.zip
		  			}).then(res => {
						this.platformMerchantStatementDialog = { modal: false }
		  				this.$message.success(res.data)
		  				this.getSnhMerchantPageFn();
		  			}).finally(() => {
		  			  this.tableLoading = false
		  			})
	  },
	  //6.40	平台商户对账单下载
	  batchRefundQuery(){
		  //6.8	批量退款查询
		  			this.tableLoading = true
		  			ydBatchRefundQuery({
		  				//订单日期	必须设定
		  				settleDate:this.batchRefundQueryDialog.settleDate,
		  				//订单时间	必须设定
		  				settleDateEnd:this.batchRefundQueryDialog.settleDateEnd,
		  				//批量编号
		  				serialNumber:this.batchRefundQueryDialog.serialNumber
		  			}).then(res => {
		  				this.$message.success(res.data)
		  				this.getSnhMerchantPageFn();
						this.batchRefundQueryDialog = { modal: false }
		  			}).finally(() => {
		  			  this.tableLoading = false
		  			})
	  },
	  //6.45	二级商户信息查询
	  secondaryMerchantInformationQueryFn(){
		  this.tableLoading = true
		  secondaryMerchantInformationQuery({
		  			  subMerId:this.auditShow.subMerId
		  }).then(res => {
			if(res.code == 200 ){
			//查到信息在弹窗显示
			this.auditShow = { modal: true}
			console.info("二级商户信息查询",this.auditShow.subMerId)
			this.auditShow.data = res.data
		    if(res.data.accountRecords.length > 0){
		    this.auditShow.data.subAccountRecords = res.data.accountRecords[0]
		     }
			}else{
				this.$message.success(res.msg)
			}
		   this.getSnhMerchantPageFn()
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //查询POS(二级)商户T日清算金额
	  queryTheSettlementAmountOfPosSecondaryMerChantOntDay(){
		  this.tableLoading = true
		  ydQuerySubMerTdaySettleRequest({
		  	//二级商户号
		  	subMerchantNo:this.queryTheSettlementAmountOfPosSecondaryMerChantOntDayDialog.subMerId,
		  	//清算日期
		  	trxDate:this.queryTheSettlementAmountOfPosSecondaryMerChantOntDayDialog.trxDate,
			//清算日期截止
			trxDateEnd:this.queryTheSettlementAmountOfPosSecondaryMerChantOntDayDialog.trxDateEnd
		  }).then(res => {
			this.queryTheSettlementAmountOfPosSecondaryMerChantOntDayDialog = { modal: false }
		  	this.$message.success(res.data)
		  	this.getSnhMerchantPageFn();
		  }).finally(() => {
		    this.tableLoading = false
		  })
	  },
	  //1 第三方POS对账单下载
	  thirdPartyPosStatementDownload(){
		  
	  },
	  //二级商户标记删除
	  delSnhMerchantPageFn(id) {
		  console.info("二级商户标记删除",id);
	    this.tableLoading = true
	    delSnhMerchantPage({id:id}).then(res => {
	     this.$message.success(res.msg)
	     this.getSnhMerchantPageFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })	},
	  editBtn(t,row) {
		  //1新增 2修改 3列表查看图片 4查看里面的图片放大 5删除 6状态变更
		  if(t == 1){
			 this.editData = {
			   modal: true,
			   userId: '',
			   add: 1,
			   word: '',
			   chinese: '',
			   picture: []
			 }
		  }else if(t == 2){
			  console.info(row,"修改商户")
			  this.editData = {
			    modal: true,
			    id: row.id,
			    add: 2,
			    //二级商户名称
			    subMerName: row.subMerName,
			    //二级商户类型
			    subMerType:row.subMerType,
			    //排序方式
			    subMerSort:row.subMerSort,
			    //法定代表人或负责人证件类型
			    certificateType:row.certificateType,
			    //法定代表人或负责人证件编号
			    certificateNo:row.certificateNo,
			    //法定代表人或负责人名称
			    contactName:row.contactName,
			    //企业名称
			    companyName:row.companyName,
			    //企业证件类型
			    companyCertType:row.companyCertType,
			    //企业证件编号
			    companyCertNo:row.companyCertNo,
			    //收款户名
			    accountName:row.accountName,
			    //收款账号
			    account:row.account,
			    //收款银行
			    bankName:row.bankName,
			    //银行预留手机号
			    mobilePhone:row.mobilePhone,
			    //地址
			    address:row.address,
			    //收款账户类型
			    accountType:row.accountType,
			    //商户负责人联系电话
			    merMobilePhone:row.merMobilePhone,
			    //备注
			    remark:row.remark
			  }
		  }else if(t == 3) {
	      this.imgPreData = {
	        modal: true,
	        url: row.picture
	      }
	    }else if(t == 4) {
	      this.imgPreData = {
	        modal: true,
	        url: this.auditShow.data.picture
	      }
	    }else if(t == 5){
			this.$confirm(`确认要删除吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
				 let id =  row.id
			     this.delSnhMerchantPageFn(id);
			});
		}else if(t == 6){
			//商户状态变更
		this.statusData = {
		  modal: true,
		  subMerId: row.subMerId,
		  updateFlag: row.state,
		  date: [],
		  content: ''
		}
		}else if(t == 7){
			//签约
			this.signAcontractData = {
				modal: true,
				subMerId: row.subMerId,
				verificationCode:'',
				randomAmount:'',
				account:row.account
			}
		}else if(t == 8){
			this.auditShow = {
				subMerId:row.subMerId
			}
			//6.45	二级商户信息查询
			this.secondaryMerchantInformationQueryFn()
		}else if(t == 9){
			//6.53	二级商户签约短信验证码重发
			this.signUpSMS = {
				modal: true,
				 subMerId: row.subMerId,
				 subMerchantAccNo:row.account
			}
		}else if(t == 10){
			//6.35	二级商户余额查询
			console.info("6.35	二级商户余额查询",row.subMerId)
			this.secondaryMerchantBalanceQueryFn(row.subMerId)
		}else if(t == 11){
			//6.26身份验证（非页面跳转）
			console.info("6.26	身份验证（非页面跳转）");
			this.tableLoading = true
			authenticationNonPageJump({ 
				//客户类型
				customType:row.customType,
				//客户姓名
				clientName:row.accountName,
				//银行帐号
				accNo:row.account,
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType,
				//手机号
				mobileNo:row.mobilePhone,
				//网银客户号
				//customNo:'',
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 12){
			//6.24	身份验证（页面跳转）
			console.info("6.24	身份验证（页面跳转）");
			this.tableLoading = true
			authenticationPageJump({ 
				//客户类型
				customType:row.customType,
				//银行帐号
				bankCardNo:row.account,
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 13){
			//6、授权支付签约（银行端） 
			console.info("6、授权支付签约（银行端）");
			this.tableLoading = true
			authorizedPaymentSigningBankEnd({ 
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType,
				//交易渠道
				paymentLinkType:'1',
				//客户编号
				merCustomNo:row.subMerId,
				//卡类型
				cardType:'A',
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 14){
			//6.16	授权支付签约（商户端）—申请
			console.info("6.16	授权支付签约（商户端）—申请");
			this.tableLoading = true
			authorizedPaymentSigningMerchantSideApplication({ 
				//交易渠道
				paymentLinkType:'1',
				//客户编号
				merCustomNo:row.subMerId,
				//签约卡号
				cardNo:row.account,
				//卡类型
				cardType:'A',
				//手机号
				mobileNo:row.mobilePhone,
				//证件类型
				certificateType:row.certificateType,
				//证件号码
				certificateNo:row.certificateNo,
				//客户姓名
				accName:row.accountName
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 15){
			//6.17	授权支付签约（商户端）—确认
			this.authorizedPaymentSigningMerchantSideConfirmationDialog = {
				modal:true,
				//交易编号
				orderNo:row.agentSignNo,
				//验证码	
				verifyCode:this.authorizedPaymentSigningMerchantSideConfirmationDialog.verificationCode
			}
		}else if(t == 16){
			//6.18	授权支付签约（商户端）—验证码重发
			console.info("6.18	授权支付签约（商户端）—验证码重发");
			this.tableLoading = true
			authorizedPaymentSigningMerchantSideVerificationCodeResend({ 
				//交易编号	
				orderNo:row.agentSignNo,
				//签约卡号	
				cardNo:row.account
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 17 ){
			console.info("更多",row)
			//更多
			this.dialogMore = {
				  modal:true,
				  moreRow:row	  
			}
		}else if( t == 18 ){
			//同步old
			this.tableLoading = true
			ydSnhRegSubMerchantInfoRequestOld({ 
				//编号
				id: row.id
			}).then(res => {
			 this.$message.success(res.data)
			 this.getSnhMerchantPageFn()
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 19 ){
			//6.44	掌银被扫支付请求
			this.tableLoading = true
			ydSnhPalmBankIsSweptToPay({ 
				//编号
				id: row.id,
				//二级商户编号
				subMerId:row.subMerId,
				//支付二维码信息
				payCode:6235613048944148431
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 20 ){
			//6.48	二级商户信息同步（新）
			this.editData.id = row.id
			this.secondaryMerchantInformationSynchronizationNewFn()
		}else if( t == 21 ){
			//6.20	授权支付签约/解约结果查询
			this.tableLoading = true
			ydAuthorizedPaymentSigningCancelingResultQuery({
				//签约编号
				orderNo:row.agentSignNo
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 22 ){
			//6.19	授权支付解约
			this.tableLoading = true
			ydTerminationOfAuthorizedPayment({
				//交易编号
				orderNo:row.id,
				//签约编号
				agentSignNo:row.agentSignNo
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 23 ){
			// 14、交易明细查询 弹出选择框
			this.transactionDetailsData = { modal: true }
		}else if( t == 24 ){
			//6.11	对账单查询
			this.transactionAccountStatementDialog = { modal: true }
		}else if( t == 25 ){
			//6.40	平台商户对账单下载
			this.platformMerchantStatementDialog = { modal: true }
		}else if( t == 26 ){
			//6.27	预授权确认/取消
			this.tableLoading = true
			ydPreAuthorizationConfirmationCancellation({
				//交易类型
				operateType:'',
				//交易日期
				orderDate:'',
				//交易时间
				orderTime:'',
				//交易编号
				orderNo:'',
				//原交易编号
				originalOrderNo:'',
				//币种
				currencyCode:'',
				//金额
				orderAmount:'',
				//手续费金额
				fee:'',
				//附言
				merchantRemarks:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 27 ){
			//6.38	电子回单下载
			this.tableLoading = true
			ydElectronicReceiptDownload({
				//二级商户编号
				subMerchantNo:'',
				//支付订单编号
				orderNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 28 ){
			//6.40	鉴权交易结果查询（不再支持）
			this.tableLoading = true
			ydAuthenticationQuery({
				//鉴权交易编号	必须设定
				transferNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 29 ){
			//6.42	出金交易查询
			this.tableLoading = true
			ydDepositTransactionInquiry({
				//外转（出金）交易编号	必须设定
				transferNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 30 ){
			//二级商户迁移
			this.tableLoading = true
			ydSecondaryBusinessMigration({
				//源平台商户号 必须设定
				fromMerchantNo:row.subMerId,
				//待迁移二级商户编号   必须设定
				subMerchantNo:row.merchantId
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 31 ){
			//第三方POS对账单下载
			this.tableLoading = true
			ydPOSThirdFileDownloadRequest({
				//二级商户号
				subMerchantID:row.subMerId,
				//对账单下载日期
				fileDate:'2021/03/24'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 32){
			//查询POS（二级）商户T日清算金额 
			this.queryTheSettlementAmountOfPosSecondaryMerChantOntDayDialog = {subMerId:row.subMerId,modal: true }
		}else if( t == 33 ){
			//3、第三方POS订单登记
			this.tableLoading = true
			ydRegisterPOSOrderRequest({
				//二级商户号
				subMerchantNo:'',
				//订单号
				orderNo:'',
				//订单日期
				orderDate:'',
				//序列号
				sequenceNo:'',
				//订单金额
				amount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 34 ){
			//4、第三方交易渠道订单确认 
			this.tableLoading = true
			ydThirdConfirmSendMQOrderRequest({
				//订单号
				orderNo:'',
				//确认订单号
				newOrderNo:'',
				//确认金额
				orderAmount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 35 ){
			//5、第三方交易渠道订单同步
			this.tableLoading = true
			ydBatchRegisterRequest({
				//批次号
				batchNo:'',
				//批次日期
				batchDate:'',
				//批次日期
				batchTime:'',
				//本批次笔数
				batchCount:'',
				//本批次金额
				batchAmount:'',
				//交易总笔数
				totalCount:'',
				//交易总金额
				totalAmount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 36 ){
			//支付请求服务器
			//6.3	支付请求  6.3.1	方式1：通过与农行服务器建立连接访问农行支付平台服务
			this.tableLoading = true
			ydPaymentRequest({
				//商户id
				id:row.id,
				//商户号
				splitMerchantID:row.subMerId,
				//交易类型 -- ImmediatePay：直接支付   PreAuthPay：预授权支付  DividedPay：分期支付
				payTypeID:'ImmediatePay',
				//交易金额
				orderAmount:'0.01',
				//手续费金额
				fee:'',
				//支付账户
				accountNo:'6228480661502423618',
				//订单说明
				orderDesc:'test',
				//订单说明url
				orderURL:'t1',
				//收货地址
				receiverAddress:'安徽省合肥市滨湖区未来塔B座1301室',
				//分期标识		必须设定，1：分期；0：不分期
				installmentMark:'0',
				//分期代码		分期标识为“1”时必须设定
				installmentCode:'',
				//分期期数		分期标识为“1”时必须设定，0-99
				installmentNum:'',
				//商品种类		必须设定，
				// 充值类 0101:支付账户充值
				// 消费类 0201:虚拟类,0202:传统类,0203:实名类
				// 转账类 0301:本行转账,0302:他行转账
				// 缴费类 0401:水费,0402:电费,0403:煤气费,0404:有线电视费,0405:通讯费,
				// 0406:物业费,0407:保险费,0408:行政费用,0409:税费,0410:学费,0499:其他
				// 理财类 0501:基金,0502:理财产品,0599:其他
				commodityType:'0201',
				//客户IP			非必须
				buyIP:'192.168.1.1',
				//设定订单保存时间	非必须
				expiredDate:'100',
				//支付类型		必须设定，
				// 1：农行借记卡支付
				// 2：国际卡支付
				// 3：农行贷记卡支付
				// 5：B2B跨行支付
				// 6：银联跨行支付
				// 7：农行对公账户支付
				// （含银联跨行B2B支付）
				// A:支付方式合并（包括1和3）
				paymentType:'A',
				//交易渠道		必须设定，
                // 1：internet网络接入
				// 2：手机网络接入
				// 3：数字电视网络接入
				// 4：智能客户端
				paymentLinkType:'1',
				//银联跨行移动支付接入方式	    非必须，但是如果选择的支付帐户类型为6(银联跨行支付)交易渠道为2(手机网络接入)，必须设定
				// 0：页面接入
				// 1：客户端接入（仅支持方式一，方式二不支持）
				unionPayLinkType:'',
				//收款方账号		非必须
				receiveAccount:'6228480661502423618',
				//收款方户名		非必须
				receiveAccName:'黄开亮',
				//通知方式		必须设定，
				// 0：URL页面通知
				// 1：服务器通知
				notifyType:'1',
				//附言			非必须
				merchantRemarks:'',
				//交易是否直接入二级商户账户  	非必须,0:否  1:是
				receiveMark:'1',
				//收款方账户类型	非必须, 0:个人 1:对公
				receiveMerchantType:'0',
				//交易是否分账；是否支持向二级商户入账	必须设定，
				//  0:否
				// 	1:是（资金分账商户必须填1）
				isBreakAccount:'1',
				//分账模版编号         非必须，交易选择分账时必输
				splitAccTemplate:'1'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 37 ){
			//6.3	支付请求  6.3.2	方式2：通过页面传参提交表单方式访问农行支付平台服务
			this.tableLoading = true
			ydPaymentRequestTwo({
				//交易类型 -- ImmediatePay：直接支付   PreAuthPay：预授权支付  DividedPay：分期支付
				payTypeID:'ImmediatePay',
				//交易金额
				orderAmount:'0.01',
				//手续费金额
				fee:'',
				//支付账户
				accountNo:'',
				//订单说明
				OrderDesc:'',
				//订单说明url
				OrderURL:'',
				//收货地址
				receiverAddress:'',
				//分期标识		必须设定，1：分期；0：不分期
				installmentMark:'',
				//分期代码		分期标识为“1”时必须设定
				installmentCode:'',
				//分期期数		分期标识为“1”时必须设定，0-99
				installmentNum:'',
				//商品种类		必须设定，
				// 充值类 0101:支付账户充值
				// 消费类 0201:虚拟类,0202:传统类,0203:实名类
				// 转账类 0301:本行转账,0302:他行转账
				// 缴费类 0401:水费,0402:电费,0403:煤气费,0404:有线电视费,0405:通讯费,
				// 0406:物业费,0407:保险费,0408:行政费用,0409:税费,0410:学费,0499:其他
				// 理财类 0501:基金,0502:理财产品,0599:其他
				commodityType:'0201',
				//客户IP			非必须
				buyIP:'',
				//设定订单保存时间	非必须
				expiredDate:'',
				//支付类型		必须设定，
				// 1：农行借记卡支付
				// 2：国际卡支付
				// 3：农行贷记卡支付
				// 5：B2B跨行支付
				// 6：银联跨行支付
				// 7：农行对公账户支付
				// （含银联跨行B2B支付）
				// A:支付方式合并（包括1和3）
				paymentType:'A',
				//交易渠道		必须设定，
			    // 1：internet网络接入
				// 2：手机网络接入
				// 3：数字电视网络接入
				// 4：智能客户端
				paymentLinkType:'1',
				//银联跨行移动支付接入方式	    非必须，但是如果选择的支付帐户类型为6(银联跨行支付)交易渠道为2(手机网络接入)，必须设定
				// 0：页面接入
				// 1：客户端接入（仅支持方式一，方式二不支持）
				unionPayLinkType:'',
				//收款方账号		非必须
				receiveAccount:'',
				//收款方户名		非必须
				receiveAccName:'',
				//通知方式		必须设定，
				// 0：URL页面通知
				// 1：服务器通知
				notifyType:'1',
				//附言			非必须
				merchantRemarks:'',
				//交易是否直接入二级商户账户  	非必须,0:否  1:是
				receiveMark:'',
				//收款方账户类型	非必须, 0:个人 1:对公
				receiveMerchantType:'',
				//交易是否分账；是否支持向二级商户入账	必须设定，
				//  0:否
				// 	1:是（资金分账商户必须填1）
				isBreakAccount:'1',
				//分账模版编号         非必须，交易选择分账时必输
				splitAccTemplate:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 38 ){
			//6.13	网上K码支付—支付请求
			this.tableLoading = true
			ydOnlineKCodePaymentPaymentRequest({
				//交易金额
				orderAmount:'0.01',
				//手续费金额
				fee:'',
				//客户姓名
				accName:'',
				//证件类型
				certificateType:'',
				//证件号码
				certificateID:'',
				//卡有效期
				expDate:'',
				//cvv2
				cvv2:'',
				//验证码
				verifyCode:'',
				//支付账户类型	必须设定，
				// 1：农行借记卡支付
				// 2：国际卡支付
				// 3：农行贷记卡支付
				paymentType:'1',
				//交易渠道
				payLinkType:'1',
				//备注
				merchantRemarks:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 39 ){
			//6.12	网上K码支付—账单发送
			this.tableLoading = true
			ydOnlineKcodePaymentBillSending({
				//订单支付有效期 非必须
				orderTimeoutDate:'12',
				//交支付订单号	  必须设定
				orderNo:'12',
				//交易金额	  必须设定
				orderAmount:'0.01',
				//订单保存时间	  非必须
				expiredDate:'',
				//订单描述	  非必须
				orderDesc:'',
				//收货地址	  非必须
				receiverAddress:'',
				//客户交易IP	  非必须
				buyIP:'',
				//卡号			必须设定
				cardNo:'6228480661502423618',
				//手机号后四位	       必须设定
				mobileNo:'5702',
				//商品种类	       必须设定，
				// 充值类 0101:支付账户充值
				// 消费类 0201:虚拟类,0202:传统类,0203:实名类
				// 转账类 0301:本行转账,0302:他行转账
				// 缴费类 0401:水费,0402:电费,0403:煤气费,0404:有线电视费,0405:通讯费,
				// 0406:物业费,0407:保险费,0408:行政费用,0409:税费,0410:学费,0499:其他
				// 理财类 0501:基金,0502:理财产品,0599:其他
				commodityType:'0201',
				//是否分期	  必须设定，1：分期；0：不分期
				installment:'0',
				//分期代码	  非必须
				projectID:'',
				//分期期数	  非必须，但分期标识为1时必须设定。
				// 分期期数0-99
				period:'',
				//支付账户类型	  必须设定，
				// 1：农行借记卡支付
				// 3：农行贷记卡支付
				// A:支付方式合并,
				paymentType:'A',
				//交易渠道	  必须设定，
				// 1：internet网络接入
				// 2：手机网络接入
				// 3:数字电视网络接入
				// 4:智能客户端
				paymentLinkType:'1',
				//收款方账号	  非必须
				receiveAccount:'',
				//收款方户名	  非必须
				receiveAccName:'',
				//二级商户备注	  非必须
				merchantRemarks:'0',
				//交易是否支持向二级商户入账  必须设定，0：否，1：是
				//（资金分账商户必须填1）
				isBreakAccount:'',
				//分账模版编号         非必须，交易选择分账时必输
				//4、设定二级商户入账信息
				splitAccTemplate:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 40 ){
			//6.14	网上K码支付—验证码重发
			this.tableLoading = true
			ydOnlineKCodePaymentVerificationCodeRetransmission({
				//支付订单编号
				orderNo:'1',
				//订单金额
				orderAmount:'0.01'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 41 ){
			//6.22	批量授权扣款
			this.tableLoading = true
			ydBatchAuthorizedDeduction({
				//交易批次号
				batchNo:'01',
				//批次总笔数
				agentCount:'0',
				//批次总金额
				agentAmount:'0.00',
				//收款方账号		非必须
				receiveAccount:'6228480661502423618',
				//收款方户名
				receiveAccName:'黄开亮'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 42 ){
			//6.23	批量授权扣款结果查询
			this.tableLoading = true
			ydBatchAuthorizationDeductionResultQuery({
				//批次编号
				batchNo:'01',
				//批次日期
				batchDate:'2021/04/11'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 43 ){
			//6.33	内转交易请求
			this.tableLoading = true
			ydInternalTransferTransactionRequest({
				//交易编号
				internalTransferNo:'01',
				//转出方二级商户编号	   必须设定
				remitterSubMerchantNo:'Gm2021041001704',
				//转入方二级商户编号     必须设定
				remitteeSubMerchantNo:'cu10086',
				//金额   必须设定
				amount:'0.01'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 44 ){
			this.secondaryMerchantsPaymentTransaction = { 
			modal:true,
			//二级商户编号
			subMerId:row.subMerId,
			//收款账号
			account:row.account,
			//收款账户名 必须设定
			accountName:row.contactName,
			//二级商户类型
			subMerType:row.subMerType,
			//二级商户名称
			subMerName:row.subMerName
			}
		}else if( t == 45 ){
			this.weChatAlipayBillPaymentDialog = { modal: true }
		}else if( t == 46 ){
		this.downloadInternalTransferOutStatementDialog = { modal: true }
		}else if(t == 47 ){
			//7.4	担保确认查询请求
			this.tableLoading = true
			ydGuaranteeConfirmationInquiryRequest({
				//担保确认交易编号
				orderNo:'01',
				//二级商户号
				subMerchantNo:row.subMerId,
				//支付订单号
				orignalOrderNo:'1212312312'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 48 ){
			//7.3	担保确认请求
			this.tableLoading = true
			ydGuaranteeConfirmationRequest({
				//支付订单号
				orderNo:'123',
				//担保确认交易编号
				confirmedOrderNo:'123',
				//订单金额
				orderAmount:'0.01',
				//是否垫资
				advancedFund:'0',
				//二级商户编号
				splitMerchantID:'12',
				//分账金额
				splitAmount:"0.01"
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 49 ){
			//6.47	支出类账簿入金交易请求
			this.tableLoading = true
			ydPaymentTransactionRequestOfExpenseAccountBook({
				//订单金额
				orderAmount:'0.01',
				//订单描述
				orderDesc:'test',
				// 支付接入方式 必须设定，
				// 1：internet网络接入
				// 2：手机网络接入
				// 3：数字电视网络接入
				// 4：智能客户端
				paymentLinkType:'1',
				//二级商户编号 必须设定
				receiveSubMerchantNo:row.subMerId,
				//附言
				merchantRemarks:'附言'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 50 ){
			//6.43	刷卡支付订单撤销请求
			this.tableLoading = true
			ydCreditCardPaymentOrderCancellationRequest({
				//支付订单编号
				orderNo:'01',
				//二级商户号
				subMchNO:row.subMerId,
				//商户模式	必须设定 1:大商户模式，0：非大商户模式
				modelFlag:'0',
				//支付渠道	必须设定 W:微信，Z：支付宝
				merchantFlag:'W'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 51 ){
			//6.21	单笔授权扣款
			this.tableLoading = true
			ydSingleAuthorizedDeduction({
				//签约编号	必须设定
				agentSignNo:'01',
				//签约卡号	非必须
				cardNo:'6228480661502423618',
				//订单金额	必须设定
				amount:'0.01',
				//收货地址	非必须
				receiverAddress:'',
				//手续费金额	非必须
				fee:'',
				//证件号码	必须
				certificateNo:'340421199303203036',
				//分期标识	必须设定
				installmentMark:'0',
				//分期代码 	非必须
				installmentCode:'',
				//分期期数	非必须
				installmentNum:'',
				//商品种类	必须设定
				// 充值类 0101:支付账户充值
				// 消费类 0201:虚拟类,0202:传统类,0203:实名类
				// 转账类 0301:本行转账,0302:他行转账
				// 缴费类 0401:水费,0402:电费,0403:煤气费,0404:有线电视费,0405:通讯费,
				// 0406:物业费,0407:保险费,0408:行政费用,0409:税费,0410:学费,0499:其他
				// 理财类 0501:基金,0502:理财产品,0599:其他
				commodityType:'0201',
				//交易渠道	必须设定
				paymentLinkType:'1',
				//客户交易IP	非必须
				buyIP:'',
				//订单保存时间	非必须
				expiredDate:'',
				//收款方账号	非必须
				receiveAccount:'',
				//收款方户名	非必须
				receiveAccName:'',
				//备注		非必须
				merchantRemarks:'',
				//交易是否支持向二级商户入账  必须设定，0：否，1：是
				// （资金分账商户必须填1）
				isBreakAccount:'0',
				//分账模版编号
				// 非必须，交易选择分账时必输
				splitAccTemplate:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 52 ){
				this.batchRefundQueryDialog = { modal: true }
		}else if( t == 53 ){
			//6.7	批量退款
			this.tableLoading = true
			ydBatchRefund({
				//批量编号		必须设定
				batchNo:'01',
				//商户退款账号
				merRefundAccountNo:'1231',
				//商户退款名
				merRefundAccountName:'3213',
				//总笔数			必须设定
				totalCount:'0',
				//总金额  		必须设定
				totalAmount:'0.00'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 54 ){
			//6.31	支付宝支付请求
			this.tableLoading = true
			ydAlipayPaymentRequest({
				//交易渠道
				paymentLinkType:'1',
				//交易类型
				payTypeID:'ALI_CREATE',
				//支付方式
				paymentType:'9',
				//通知方式
				notifyType:'1',
				//商品种类
				commodityType:'0201',
				//交易金额
				orderAmount:'0.01',
				//交易是否分账
				isBreakAccount:'1',
				//附言
				merchantRemarks:'支付宝',
				//支付账户
				accountNo:'12354534534'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 55 ){
			//6.30	微信支付请求
			this.tableLoading = true
			ydWechatPaymentRequest({
				//交易类型	  必须设定
				payTypeID:'JSAPI',
				//订单有效期		非必须
				orderTimeoutDate:'11',
				//支付订单编号		必须设定
				orderNo:'123',
				//交易金额		必须设定
				orderAmount:'0.01',
				//手续费金额		非必须
				fee:'',
				//指定付款账户
				accountNo:'',
				//订单说明		必输
				orderDesc:'微信展示',
				//交易渠道		必须设定，
				paymentLinkType:'1',
				//支付方式
				paymentType:'8',
				//通知方式
				notifyType:'1',
				//商品种类
				commodityType:'0201',
				//交易是否支持向二级商户入账
				isBreakAccount:'1',
				//附言			非必须
				merchantRemarks:'',
				//指定付款账户
				accountNo:'123',
				//分账商户编号
				splitMerchantID:row.subMerId
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 56 ){
			//扫码支付
			this.tableLoading = true
			ydPaymentByScanningCode({
				//商户id
				id:row.id,
				//金额
				money:'0.01',
				//支付二维码信息
				payCode:'123'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 57 ){
			//商户收款码
			ydGetCollectionCode({
				//商户编号
				id:row.id
			}).then(res => {
				if(res.code == 200){
					//收款码
					this.collectionCodeDialog = { 
					  modal: true
					 }
					 this.collectionCodeUrl = res.data
				}else{
					this.collectionCodeDialog = {
					  modal: true,
					  msg:res.msg
					 }
					this.$message.success(res.msg)
				}
				console.info("查看商户二维码响应参数:",this.collectionCodeDialog)
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 58 ){
			//商户收款码放大
			this.imgPreData = {
			  modal: true,
			  url: this.collectionCodeUrl
			}
		}else if( t == 59 ){
			//商户列表收款码放大
			this.imgPreData = {
			  modal: true,
			  url: row.merQrCodeUrl
			}
		}else if( t == 60 ){
			//商户列表收款码logo版放大
			this.imgPreData = {
			  modal: true,
			  url: row.merQrCodeLogoUrl
			}
		}else if( t == 61 ){
			console.info("二级商户证照资料上传")
			//二级商户证照资料上传
			this.uploadSubMerCertRequestDialog = {
				modal:true,
				subMerId:row.subMerId,
				flag:this.uploadSubMerCertRequestDialog.flag,
				subMerCertFile:this.uploadSubMerCertRequestDialog.subMerCertFile
				}
		}else if( t == 62 ){
			//统一协议支付签约申请
			this.tableLoading = true
			ydUnifiedSignApply({
				//签约客户证件类型
				certificateType:"I",
				//签约客户证件号
				certificateNo:'01',
				//客户银行卡号
				cardNo:'12',
				//客户姓名
				accName:'12',
				//客户手机号
				mobileNo:'12',
				//签约流水号，对农行卡签约同时也是签约协议号
				orderNo:'123',
				//签约交易渠道，1：PC渠道 2：手机渠道 3:电视渠道 4:智能客户端
				paymentLinkType:'2',
				//签约失效时间，仅对农行卡生效，他行卡不受该字段限制
				invaidDate:'13',
				//签约客户号，仅对农行卡生效，他行卡不受该字段限制，通过修改该字段，允许农行卡与同一商户重复签约
				merCustomNo:'12'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t ==63 ){
			//二级商户账簿余额查询  弹出选择框
			this.secondaryMerchantAccountBookDetailsQueryData = { modal: true,subMerId:row.subMerId }
		}else if( t == 64 ){
			//担保出金All
			this.tableLoading = true
			ydTestGuaranteePayment({
				advancedFund:"0"
			}).then(res => {
				this.$message.success(res.data)
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 65 ){
			//商户支持支付方式
			this.merchantSupportsPaymentMethodDialog = {
				modal:true,
				id:row.id,
				merchantName:row.subMerName,
				//支付渠道 数组
				paymentChannelsArray:row.paymentChannelsArray
			}
		}else if( t == 66 ){
			//担保出金one
			this.tableLoading = true
			ydGuaranteedWithdrawalOne({
			    //商户编号
				id:row.id,
				//是否垫资 非垫资
				advancedFund:'0'
			}).then(res => {
				this.$message.success(res.data)
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 67 ){
			//担保出金(垫资)one
			this.tableLoading = true
			ydGuaranteedWithdrawalOne({
			    //商户编号
				id:row.id,
				//是否垫资 垫资
				advancedFund:'1'
			}).then(res => {
				this.$message.success(res.data)
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 68 ){
			//担保出金All垫资
			this.tableLoading = true
			ydTestGuaranteePayment({
				advancedFund:"1"
			}).then(res => {
				this.$message.success(res.data)
			}).finally(() => {
			  this.tableLoading = false
			})
		}
	},
	//二级商户信息保存
	SecondaryMerchantsSynchronizeNewFn(){
	this.tableLoading = true
	SecondaryMerchantsSynchronizeNew({ 
		//编号
		id:this.editData.id,
		//二级商户编号
		subMerId:this.editData.subMerId,
		//二级商户名称
		subMerName: this.editData.subMerName,
		//二级商户类型
		subMerType:this.editData.subMerType,
		//排序方式
		subMerSort:this.editData.subMerSort,
		//状态 0:关闭 1:正常
		status:1,
		//法定代表人或负责人证件类型
		certificateType:this.editData.certificateType,
		//法定代表人或负责人证件编号
		certificateNo:this.editData.certificateNo,
		//法定代表人或负责人名称
		contactName:this.editData.contactName,
		//企业名称
		companyName:this.editData.companyName,
		//企业证件类型
		companyCertType:this.editData.companyCertType,
		//企业证件编号
		companyCertNo:this.editData.companyCertNo,
		//收款户名
		accountName:this.editData.accountName,
		//收款账号
		account:this.editData.account,
		//收款银行
		bankName:this.editData.bankName,
		//银行预留手机号
		mobilePhone:this.editData.mobilePhone,
		//地址
		address:this.editData.address,
		//收款账户类型
		accountType:this.editData.accountType,
		//商户负责人联系电话
		merMobilePhone:this.editData.merMobilePhone,
		//备注
		remark:this.editData.remark
	}).then(res => {
	 this.$message.success(res.msg)
	 this.tableLoading = false
	 this.editData.modal = false
	 //刷新
	 this.getSnhMerchantPageFn() 
	}).finally(() => {
	  this.tableLoading = false
	}) 
	},
	//6.53	二级商户签约短信验证码重发
	signUpSMSBtn(){
		console.info("二级商户签约短信验证码重发",this.signUpSMS.subMerId);
		this.tableLoading = true
		sendMobileMessageForSubMerRequest({
					  subMerId:this.signUpSMS.subMerId,
					  subMerchantAccNo:this.signUpSMS.subMerchantAccNo
		}).then(res => {
		 this.$message.success(res.msg)
		 this.tableLoading = false
		}).finally(() => {
		  this.tableLoading = false
		}) 
	},
	//出金交易请求
	secondaryMerchantsPaymentTrans(){
		//6.34	出金交易请求
		this.tableLoading = true
		ydCashTransactionRequest({
			//二级商户编号
			subMerId:this.secondaryMerchantsPaymentTransaction.subMerId,
			//收款账号
			account:this.secondaryMerchantsPaymentTransaction.account,
			//收款账户名          必须设定
			accountName:this.secondaryMerchantsPaymentTransaction.accountName,
			//出金金额
			trxAmount:this.secondaryMerchantsPaymentTransaction.amountOfMoney,
			//二级商户类型
			subMerType:this.secondaryMerchantsPaymentTransaction.subMerType,
			//二级商户名称
			subMerName:this.secondaryMerchantsPaymentTransaction.subMerName,
			//关联的支付订单号
			//orderNo:'12',
			//是否关联支付订单编号，0:不关联，1:关联
			//drawingFlag:'1',
			//附言                非必须
			//remark:'test',
			//他行行号		  12位，他行出金金额大于50000时必输
			//recBankNo:''		
		}).then(res => {
			this.secondaryMerchantsPaymentTransaction = {
			modal : false
		     }
			this.$message.success(res.data)
			this.getSnhMerchantPageFn();
			
		}).finally(() => {
		  this.tableLoading = false
		})
	},
	addBtn (t) {
	  if (this.editData.add == 1) {
		  //添加
		  this.SecondaryMerchantsSynchronizeNewFn()
	  } else {
		  //修改
		this.SecondaryMerchantsSynchronizeNewFn()
	  }
	},
	uploadSave() {
	  if (this.imgUploadData.urlList && this.imgUploadData.urlList.length) {
	    addImage(this.imgUploadData.urlList.map(item => ({pictureUrl: item}))).then(res => {
	      this.$message.success(res.data)
	      this.imgUploadData.modal = false
	      this.getImagePageFn()
	    })
	  }
	},
      pageChange (val) {
        this.pages.page = val
        this.getSnhMerchantPageFn()
      },
	  //显示或隐藏
	  toggle(){
		this.showOrHide = !this.showOrHide //取反
	  },
	  //选择框
	  handleCheckedCitiesChange(value) {
	         //let checkedCount = value.length;
	  			//this.$message.success(checkedCount)
	  			
	  			//alert(value)
	  },
	  //商户支持支付方式
	  merchantSupportsPaymentMethodDialogBtn(){
		  this.tableLoading = true
		  ydMerchantSupportsPaymentMethod({
		  			  id:this.merchantSupportsPaymentMethodDialog.id,
		  			  paymentChannels:this.merchantSupportsPaymentMethodDialog.paymentChannelsArray
		  }).then(res => {
			  if( res.code === 200 ){
			 this.merchantSupportsPaymentMethodDialog = {
				  	modal:false }
			  }else{
				  this.$message.success(res.msg)
			  }
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
		  
	  }
    }
  }
</script>

<style scoped>
  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }

  .type-ul {
    margin-top: 10px;
    max-height: 400px;
    overflow: auto;
  }

  .type-li {
    display: flex;
    align-items: center;
    line-height: 40px;
    border-bottom: 1px solid #d0d3da;
  }

  .type-li p {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
